import { render } from "./ScheduleUnblockModal.vue?vue&type=template&id=10b0e1d8&scoped=true"
import script from "./ScheduleUnblockModal.vue?vue&type=script&lang=js"
export * from "./ScheduleUnblockModal.vue?vue&type=script&lang=js"

import "./ScheduleUnblockModal.vue?vue&type=style&index=0&id=10b0e1d8&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b0e1d8"]])

export default __exports__